import { request } from './client'

/* **W-134 — WHAT IS SIGNED IN TO THIS HOTEL, AND FROM WHAT KIND OF THING.** Sprint 71.

   **THE SCREEN IS CALLED "DEVICES" AND THERE IS NO SUCH THING IN THIS PRODUCT.** Nothing
   issues a device an identity; the only evidence is the `User-Agent`, which becomes one of
   eight coarse codes or, honestly, nothing. Two identical Android handsets are
   indistinguishable here and always will be — so a row is a GROUPING of sessions, not a
   device, and the screen says so rather than letting a plausible list be read as a true
   one. */

export interface DeviceRow {
  userId: string
  employeeId: string
  person: string
  personAr: string | null
  /** A `Devices` code, or **null when nothing matched** — drawn as "Unknown device". */
  device: string | null
  /** How many live sessions this row holds. **More than one is not more than one device.** */
  liveSessions: number
  lastSeenAtUtc: string
  /** Against a `lastSeen` written at most once a minute, so the screen says "2 min ago". */
  minutesSinceSeen: number
  firstIssuedAtUtc: string
  /** Every distinct raw string behind the grouping. More than one PROVES two devices;
   *  one proves nothing, because identical handsets send identical strings. */
  userAgents: string[]
  /** So the screen can end them through the endpoint W-121 already uses. */
  sessionIds: string[]
}

export interface DeviceRegisterView {
  liveSessions: number
  people: number
  /** Live sessions whose agent matched nothing. Counted and named, never hidden. */
  unknown: number
  /** Rows holding more than one session — the honest measure of what this cannot tell. */
  groupings: number
  /** Rows live but unseen for a day. The rows this screen exists to surface. */
  stale: number
  rows: DeviceRow[]
}

export const fetchDevices = (
  propertyId: string, options: { signal?: AbortSignal } = {},
) => request<DeviceRegisterView>(
  `/properties/${propertyId}/devices`,
  options.signal ? { signal: options.signal } : {})

/* **ENDING A SESSION IS NOT DEFINED HERE.** `endSession` in `api/users.ts` is the act
   W-121 already has, and this screen imports it — a second one would be a second
   expression of a call that writes an audit row, and the two would disagree the day one
   of them changed. */
